import { createSelector } from 'reselect'
import getByVariantIdDeepProductSelector from 'modules/product/redux/selectors/get-by-variant-id-deep'

const getSampleOrFullSizeProductVariantSelector = ({
  productVariantSample,
  shouldShowFullSizeConversion
}) => createSelector(
  getByVariantIdDeepProductSelector(productVariantSample.fullsize_variant_id),
  (
    fullSizeProductVariant = {}
  ) => {
    const shouldLog = productVariantSample?.fullsize_variant_id === 45691300741340
    shouldLog && logUtil('getSampleOrFullSizeProductVariantSelector').debug('[start] fullSizeProductVariant=', fullSizeProductVariant)

    if (
      shouldShowFullSizeConversion &&
      Object.keys(fullSizeProductVariant || {}).length > 0
    ) {
      return fullSizeProductVariant
    }

    return productVariantSample
  }
)

export default getSampleOrFullSizeProductVariantSelector
